import { FormField } from '@portals/api';

export type FormData = {
	value: string;
	form_field: FormField;
};
